import Layout from '@/components/feature/Layout';
import { servicesData } from '@/mocks/codesajan';

const colorMap: Record<string, { bg: string; icon: string }> = {
  'ri-water-flash-line': { bg: 'bg-primary-50', icon: 'text-primary-600' },
  'ri-drop-line': { bg: 'bg-accent-50', icon: 'text-accent-600' },
  'ri-tools-line': { bg: 'bg-secondary-50', icon: 'text-secondary-600' },
  'ri-customer-service-2-line': { bg: 'bg-primary-50', icon: 'text-primary-600' },
};

export default function ServicesPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20water%20treatment%20facility%20with%20clear%20water%20flowing%20through%20large%20industrial%20pipes%2C%20water%20distribution%20system%20with%20blue%20valves%2C%20professional%20clean%20industrial%20aesthetic%2C%20bright%20natural%20daylight%2C%20editorial%20photography%20style%2C%20clean%20simple%20background%20with%20space%20for%20text&width=1800&height=600&seq=services-hero-water-plant&orientation=landscape"
            alt="Sistema de distribución de agua en San Jacinto Norte"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Servicios
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Nuestros Servicios
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Brindamos servicios integrales de agua para las familias de San Jacinto Norte Zona Oeste.
          </p>
        </div>
      </div>

      {/* Services grid */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {servicesData.map((service) => {
            const colors = colorMap[service.icon] || colorMap['ri-water-flash-line'];
            return (
              <div
                key={service.id}
                className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover-lift transition-all duration-400 hover:-translate-y-1"
              >
                <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mb-4`}>
                  <i className={`${service.icon} ${colors.icon} text-xl w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950 mb-2">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <ul className="space-y-1.5">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-foreground-500">
                      <i className="ri-check-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}